import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';
import { createServerRootMixin } from 'vue-instantsearch/vue3/es';

import { init, PRODUCTS_INDICES } from '@/api/algolia';

/**
 * Provide access to the SSR functions in your app
 */
export function createSearchApp(index, router, $cloneComponent) {
  const indexName = index || 'Products';
  if (!PRODUCTS_INDICES.includes(indexName)) {
    throw new Error(`Cannot search Algolia for index ${indexName}`);
  }
  const searchClient = init();
  const options = {
    $cloneComponent,
    indexName,
    searchClient,
  };
  if (router) {
    options.routing = {
      router,
      stateMapping: singleIndexMapping(indexName),
    };
  }
  return createServerRootMixin(options);
}
